import IndicatorService from 'src/modules/indicator/indicatorService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/store';
import { i18n } from 'src/i18n';

const prefix = 'INDICATOR_FORM';

const indicatorFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: indicatorFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await IndicatorService.find(id);
      }

      dispatch({
        type: indicatorFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: indicatorFormActions.INIT_ERROR,
      });

      getHistory().push('/indicator');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: indicatorFormActions.CREATE_STARTED,
      });

      await IndicatorService.create(values);

      dispatch({
        type: indicatorFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.indicator.create.success'),
      );

      getHistory().push('/indicator');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: indicatorFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, _getState) => {
    try {
      dispatch({
        type: indicatorFormActions.UPDATE_STARTED,
      });

      await IndicatorService.update(id, values);

      dispatch({
        type: indicatorFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.indicator.update.success'),
      );

      getHistory().push('/indicator');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: indicatorFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default indicatorFormActions;
